import { Link as RouterLink } from "react-router-dom"
import { Button, Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react"
import { ChevronDownIcon } from "@chakra-ui/icons"

const PrintLink = ({ linkId, category, orderId, label }) => (
  <MenuItem
    as={RouterLink}
    to={`/admin/cartellini/${linkId}/${category}/${orderId}`}
    target="_blank"
    rel="noopener"
  >
    {label}
  </MenuItem>
)

const PrintMenu = ({ linkId, orderId, hasFresco, hasGastro, withZones }) =>
  hasFresco || hasGastro || withZones ? (
    <Menu placement="bottom-end">
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        colorScheme="teal"
      >
        Cartellini
      </MenuButton>
      <MenuList>
        {!!hasFresco && (
          <PrintLink
            linkId={linkId}
            orderId={orderId}
            category="fresco"
            label="Fresco"
          />
        )}
        {!!hasGastro && (
          <PrintLink
            linkId={linkId}
            orderId={orderId}
            category="gastro"
            label="Gastronomia"
          />
        )}
        {!!withZones && (
          <MenuItem
            as={RouterLink}
            to={`/admin/cartellini_zone/${linkId}`}
            target="_blank"
            rel="noopener"
          >
            Per Zone
          </MenuItem>
        )}
      </MenuList>
    </Menu>
  ) : null

export default PrintMenu
